module.exports = __webpack_public_path__ + "img/a723e0c.jpg";